import { StaggeredAnimation } from "#components/animation/StaggeredAnimation.tsx";
import { StaggeredAnimationItem } from "#components/animation/StaggeredAnimationItem.tsx";
import { getSourceKey, type NumberedCitation } from "#features/citations/citedContent.ts";
import { SOURCES_MAX_STAGGER_DELAY, SourcesSidePanelCard } from "#features/conversations/components/sources-side-panel/SourcesSidePanelCard.tsx";
import { Div } from "@hopper-ui/components";

interface Props {
    citations: NumberedCitation[];
}

export const SourcesSidePanelBody = ({ citations }: Props) => {
    return (
        <Div
            overflowY="auto"
            overflowX="hidden"
            padding="inset-sm"
        >
            <StaggeredAnimation maxDelay={SOURCES_MAX_STAGGER_DELAY}>
                {citations.map(citation => (
                    <StaggeredAnimationItem key={getSourceKey(citation.source)}>
                        <SourcesSidePanelCard citation={citation} />
                    </StaggeredAnimationItem>
                ))}
            </StaggeredAnimation>
        </Div>
    );
};
